import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useState, useEffect } from 'react';

export default function Navbar() {
  const { t } = useTranslation();
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 40);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const linkClass = 'text-sm font-medium whitespace-nowrap transition-colors duration-200 hover:text-primary-500';

  return (
    <nav
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2">
            <span className="text-xl font-heading font-bold text-foreground-950 whitespace-nowrap">
              YOYBUY <span className="text-primary-500">CAM</span>
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-8">
            <Link to="/" className={linkClass}>
              {t('nav.home', 'Главная')}
            </Link>
            <a href="#categories" className={linkClass}>
              {t('nav.categories', 'Категории')}
            </a>
            <Link to="/yoybuy-spreadsheet-guide" className={linkClass}>
              {t('nav.guide', 'Руководство')}
            </Link>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full bg-primary-500 text-background-50 text-sm font-semibold whitespace-nowrap transition-all duration-200 hover:bg-primary-600"
            >
              Buy It Now
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-right-up-line text-sm"></i>
              </span>
            </a>
          </div>

          <button
            className="md:hidden w-10 h-10 flex items-center justify-center text-foreground-900"
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="Toggle menu"
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50/98 backdrop-blur-md border-t border-background-200/70">
          <div className="flex flex-col px-6 py-4 gap-3">
            <Link to="/" className={linkClass} onClick={() => setMobileOpen(false)}>
              {t('nav.home', 'Главная')}
            </Link>
            <a href="#categories" className={linkClass} onClick={() => setMobileOpen(false)}>
              {t('nav.categories', 'Категории')}
            </a>
            <Link to="/yoybuy-spreadsheet-guide" className={linkClass} onClick={() => setMobileOpen(false)}>
              {t('nav.guide', 'Руководство')}
            </Link>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full bg-primary-500 text-background-50 text-sm font-semibold whitespace-nowrap transition-all duration-200 hover:bg-primary-600 w-fit"
            >
              Buy It Now
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-right-up-line text-sm"></i>
              </span>
            </a>
          </div>
        </div>
      )}
    </nav>
  );
}